import { Field, useFormikContext } from "formik";
import React, { FC, useEffect } from "react";
import { addCustomFieldMetaData } from "../../utilities/formFields";
import DateField from "../date-field/date-field";
import Label from "../label/label";
import { generateFieldId } from '../../utilities/GenerateFieldId';

interface SettingDateFieldProps {
    accessor: string;
    displayName: string | undefined;
    validate?: (value) => any,
    detailTypeId?: number,
    required?: boolean
}

const SettingDateField: FC<SettingDateFieldProps> = ({ accessor, displayName, validate, detailTypeId = undefined, required = false }) => {
    const { errors, values, setFieldValue } = useFormikContext();

    useEffect(() => {
        addCustomFieldMetaData(detailTypeId, values, accessor, setFieldValue);
    }, [])

    return <div className="flex flex-col flex-1 pr-6 mb-2">
        <div className={'flex flex-row justify-between'} id={generateFieldId(accessor, 'DateFieldLabel')}>
            <Label htmlFor={accessor}
                required={required}
                className="text-xs text-gray-600 mt-1">{displayName}:</Label>
            {errors[accessor] ? <span className='text-red-600 text-xs pr-6'>{errors[accessor]}</span> : null}
        </div>
        <div className={'flex flex-row justify-between'} id={generateFieldId(accessor, 'DateField')}>
            <Field valueName={accessor}
                name={accessor}
                type="text"
                component={DateField}
                validate={validate}
                className='absolute' />
        </div>
    </div>
}

export default SettingDateField;


